// extracted by mini-css-extract-plugin
export default {"button":"op-z","reviewSort":"pp-z"};